import React, {Fragment} from 'react';
import i18n from 'i18next';
import Guest from '@/Layouts/Guest';
import {Head, usePage} from '@inertiajs/inertia-react';
import Button from "@/Components/Button";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";
import ProductLogo from "@/Components/ProductLogo";

export default function LoginAttemptToWrongPlatform() {

    const platformUrl = usePage().props.other_platform_url;
    const platformName = usePage().props.other_platform_name;

    function goToOtherPlatform() {
        window.location.replace(platformUrl);
    }

    function goBack() {
        window.history.back();
    }

    return (
        <Guest>
            <Head>
                <title>{i18n.t("login-attempt-to-wrong-platform.page-title")}</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className="bad-login-attempt">
                <ProductLogo />
                <Fragment>
                    <div className="instructions">
                        <h3><b>{i18n.t("login-attempt-to-wrong-platform.almost-there")}</b></h3>
                        <p>{i18n.t("login-attempt-to-wrong-platform.message")}
                            <br/>
                            <a className="wrong-platform-link" onClick={goToOtherPlatform}>{platformUrl}</a>
                        </p>
                    </div>
                    <Button type="button" className="w-100 btn btn-primary"
                    onClick={goToOtherPlatform}>
                        {i18n.t("login-attempt-to-wrong-platform.log-in-to-x", {'platform_name': platformName})}
                    </Button>
                    <a className="link wrong-platform-link" onClick={goBack}>
                        {i18n.t("login-attempt-to-wrong-platform.cancel")}
                    </a>
                </Fragment>
            </div>
        </Guest>
    );
}
